import { ValidatedInput } from '@cp-shared-19/frontend-ui';
import { useField } from 'formik';
import React from 'react';
import { sanitizeAmount } from '../../../../../../../utils';

type AmountInputProps = {
    label: string;
    name: string;
};

export const AmountInput: React.FC<AmountInputProps> = ({ label, name }) => {
    const [field, , { setValue }] = useField<string>(name);

    const sanitize = (): void => {
        const sanitized = sanitizeAmount(field.value || '');
        setValue(sanitized && isNaN(Number(sanitized)) ? '' : sanitized);
    };

    const handleBlurCapture = (): void => sanitize();

    // Enter submits without triggering blur, so sanitize explicitly
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (event.key === 'Enter') sanitize();
    };

    return (
        <ValidatedInput
            className="c-form-field--no-floating"
            label={label}
            isMandatory={true}
            name={name}
            inputMode="text"
            testId={`test-${name}`}
            maxLength={40}
            onBlurCapture={handleBlurCapture}
            onKeyDown={handleKeyDown}
            requiredText=" *"
        />
    );
};
